import { Col, Row } from 'antd';
import React, { useMemo } from 'react';

import HelpIcon from '../../components/HelpIcon';
import Text from '../../components/Text';
import { IMAGES } from '../../enum';
import { formatCurrencyToCompanyLocale } from '../../utils/numbers';
import { isWithinBounds } from './generateFavrRates.utils';

const BoundsIndicator = props => {
  const { t, value, bounds, countryCode = 'US' } = props;

  const rangeText = useMemo(() => {
    if (bounds) {
      const minFormatted = formatCurrencyToCompanyLocale(
        bounds.min,
        undefined,
        undefined,
        countryCode,
      );
      const maxFormatted = formatCurrencyToCompanyLocale(
        bounds.max,
        undefined,
        undefined,
        countryCode,
      );
      if (bounds.min === bounds.max) {
        return `${t('suggestedValue')}: ${minFormatted}`;
      }

      return `${t('suggestedValue_plural')}: ${minFormatted} - ${maxFormatted}`;
    }

    return '';
  }, [t, bounds, countryCode]);

  const withinBounds = isWithinBounds(value, bounds);
  if (withinBounds === null) {
    return null;
  }

  const statusText = withinBounds ? t('withinBounds') : t('outOfBounds');

  return (
    <Row gutter={[8, 8]} style={{ height: '25px' }} wrap={false} align="middle">
      <Col>
        <img
          src={withinBounds ? IMAGES.CIRCLE_CHECK_MARK_ICON : IMAGES.CIRCLE_REMOVE_ICON}
          alt={statusText}
          width="18px"
          height="18px"
        />
      </Col>

      <Col style={{ height: '22px' }}>
        <HelpIcon
          placement="top"
          variant="info"
          hint={
            <div>
              <Text variant="b">{statusText}</Text>
              {rangeText && <Text style={{ marginTop: 4 }}>{rangeText}</Text>}
            </div>
          }
        />
      </Col>
    </Row>
  );
};

export default BoundsIndicator;
